// extracted by mini-css-extract-plugin
export default {"TextMeasurer":"TextMeasurer_TextMeasurer__a3A7u"};